<i18n src="../../locales/lang.json"></i18n>

<template>
  <div class="container-fluid upload-container p-1">

    <div class="row">
      <div class="col">
        <div class="select_container" style="float:left">
          <select class="form-control" v-bind:id="'select_' +  getId()" data-fouc v-select='selected' v-on:change="onChange">
            <option value="" style="">{{placeholder}}</option>
            <option v-for="option in items" v-bind:value="option.Id">
              {{ option.Name }}
            </option>
          </select>
        </div>


        <button type="button" class="btn btn-outline skin primary-button text-primary-800 btn-icon ml-1" @click="displayForm" style="float:right"><i class="icon-user-plus"></i></button>

      </div>
    </div>

    <div class="row">
      <div class="input-container col-sm-12" v-if="displayAdd == true" style="float:left;">
        <input type="text" v-bind:placeholder="$t('status_name')" class="form-control" v-model="itemName">
      </div>

      <div class="text-right col-sm-12" v-if="displayAdd == true" style="float:right;">
        <button type="submit" class="btn skin primary-button mt-1" @click="createItem">{{buttontext}}</button>
      </div>
    </div>


    <div v-if="message != null && message != ''" class="col-12 alert alert-light upload-error-message" role="alert">
      <ul>
        <li class="col-12" v-for="(ms, i) in message.split('\n')" :key="i">
          {{ ms }}
        </li>
      </ul>
    </div>

  </div>
</template>

<script>


  let message = "";
  var selected = "";
  let displayAdd = false;
  var items = [];
  var itemName = "";
  var placeholder = "";
  var buttontext = "";

  export default {
    name: "status-selector",
    props: {
      
      value: {
        type: String,
        default: null
      },
    },
    data() {
      return {
        placeholder,
        buttontext,
        selected,
        message: "",
        visible: this.visibility,
        displayAdd,
        itemName,
        items
      };
    },
    methods: {
      displayForm() {
        this.displayAdd = !this.displayAdd;
      },
      getOptionStyle(v) {
        return v;
      },
      onChange() {
        this.$emit('change', $("#select_" + this.getId()).val());
      },
      input(event) {
        this.$emit('input', event.target.value);
      },
      getId() {
        return this._uid;
      },
      doChange() {
        this.selected = $("#" + 'select_' + this.getId()).val();
      },
      getData() {
        return this.items;
      },
      async createItem() {
        var request = { name: this.itemName };
        try {
          var response = await this.$http.post(
            '/api/status/Create',
            request
          ).then(async response => {
            this.load(response.data.Id);
            this.displayAdd = false;
          });

        } catch (err) {
          alert(err);
        }
      },
      async delete(id) {
        try {
          this.items = [];
          this.$http.get('/api/status/Delete?id=' + id).then(async response => {
          });
        } catch (err) {
          alert('some error:' + err)
        }
      },
      async load(selected) {
        try {
          this.items = [];
          this.$http.get('/api/status/Search?').then(async response => {

            this.items = response.data;
            $('#' + 'select_' + this.getId()).select2();

          }).then((async response => {
            if (selected != null) {
              $("#select_" + this.getId()).val(selected);
              $("#select_" + this.getId()).trigger('change');
            }
          }
          ));
        } catch (err) {
          alert('some error:' + err)
        }
      }
    },
    watch: {
      value: function (newVal, oldVal) {
        $("#select_" + this.getId()).val(newVal);
        $("#select_" + this.getId()).trigger('change');
      }
    },
    mounted() {
      this.load(this.value);
      $("#select_" + this.getId()).change(this.onChange);
      this.placeholder = this.$t('select_status');
      this.buttontext = this.$t('add_status');
    }
  };
</script>

<style scoped>
  .select_container {
    width: calc(100%)
  }
</style>




// WEBPACK FOOTER //
// src/components/status/status-selector.vue